module.exports = __webpack_public_path__ + "static/media/topseller.e35db743.jpg";